import React from 'react'
import {LoginModalOverlay} from 'common/styleguide/LoginModalOverlay'

export const PRINT_LOGGED_OUT_MODAL = 'PRINT_LOGGED_OUT_MODAL'

export const PrintLoggedOutModal = ({onRequestClose}) => (
  <LoginModalOverlay
    title='Log In to Print Route'
    onRequestClose={onRequestClose}>
    <p>
      Sign in to print customized PDFs with maps and
      cuesheets for any route on our site.
    </p>
  </LoginModalOverlay>
)
